<div  class="d-flex flex-wrap  text-left m-auto justify-content-between align-items-center">
    <p class="fs-2 w-100 text-grad mb-2">Faltam</p>
    <div class="col-12 col-md-4">
        <p class="fs-2 text-grad">Horas: <b>{{hours}}</b></p>
    </div>
    <div class="col-12 col-md-4">
        <p class="fs-2 text-grad">Minutos: <b>{{minutes}}</b></p>
    </div>
    <div class="col-12 col-md-4">
        <p class="fs-2 text-grad">Segundos: <b>{{seconds}}</b></p>
    </div>
    <p class="col-12 fs-4 mt-2 text-success">Para abrir as vendas</p>
</div>

